import moment from "moment";
import { formatHifzSessionTypeLabel } from "./associateCapabilities";
import { resolveLessonBook } from "./studentDisplay";

/**
 * @param {object} report
 * @param {(key: string, opts?: object) => string} t - i18next `t`
 */
export function formatStudentReportListRow(report, t) {
  const lessonBook = resolveLessonBook(report);
  const lessonBookName =
    lessonBook === "quran"
      ? t("lessonBook.quran")
      : lessonBook === "madani_quaida"
        ? t("lessonBook.madaniQuaida")
        : t("lessonBook.nooraniQuaida");
  const reference =
    lessonBook === "quran"
      ? t("lessonBook.partVerse", {
          part: report.part_mumber ?? report.partNumber,
          verse: report.verse_number ?? report.verseNumber,
        })
      : "";
  return {
    ...report,
    lesson_book: lessonBook,
    report_date: moment(report.report_date_time).format("DD-MM-YYYY hh:mm A"),
    quran_part_mumber: report.part_mumber ? report.part_mumber : "",
    quran_verse_number: report.verse_number ? report.verse_number : "",
    reference: `${reference} `,
    lesson_book_name: `${lessonBookName} `,
    session_type_label: formatHifzSessionTypeLabel(report.session_type, t),
  };
}
